"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedListChooserState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var multi_list_chooser_state_1 = require("./multi.list.chooser.state");
var NestedListChooserState = /** @class */ (function (_super) {
    tslib_1.__extends(NestedListChooserState, _super);
    function NestedListChooserState(field) {
        var _this = _super.call(this, field.schema.displayName) || this;
        _this.field = field;
        _this.formField = field.schema;
        _this.setValue(_this.field.value);
        return _this;
    }
    Object.defineProperty(NestedListChooserState.prototype, "displayValue", {
        get: function () {
            return this.field.hasValue() ? this.field.displayValue : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NestedListChooserState.prototype, "groups", {
        get: function () {
            var groups = [];
            var selections = this.getSelections(this.value);
            var group = this.formField.options;
            var _loop_1 = function (selection) {
                if (group == null) {
                    throw new Error("NestedList group not found for selection \"".concat(selection, "\""));
                }
                var items = group.values.map(function (groupValue, i) { return ({ key: groupValue.value, value: groupValue.value, color: groupValue.color }); });
                var selectedValue = group.values.find(function (groupValue) { return String(groupValue.value) === selection; });
                if (selectedValue == null) {
                    items.unshift({ key: selection, value: selection + '*' });
                }
                groups.push({
                    title: group.title,
                    items: items,
                    selected: selectedValue != null ? selectedValue.value : items[0].value
                });
                group = selectedValue != null ? selectedValue.options : null;
            };
            for (var _i = 0, selections_1 = selections; _i < selections_1.length; _i++) {
                var selection = selections_1[_i];
                _loop_1(selection);
            }
            return groups;
        },
        enumerable: false,
        configurable: true
    });
    NestedListChooserState.prototype.setValue = function (values) {
        if (values == null || values.length === 0) {
            this._value = null;
            return;
        }
        this._value = this.getSelections(values);
    };
    NestedListChooserState.prototype.selectDefaultValue = function () {
        this._value = this.getSelections([]);
    };
    //We need to override the generic getAllOptions function as the nested list need to keep the value of all the selected nodes instead of only the last one.
    NestedListChooserState.prototype.getAllOptions = function () {
        var options = this.formField.options.values;
        var allOptions = [];
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            NestedListChooserState.flatten(option, [], allOptions);
        }
        return allOptions;
    };
    NestedListChooserState.flatten = function (node, path, result) {
        if (path === void 0) { path = []; }
        if (result === void 0) { result = []; }
        var item = { key: node.value, value: node.value };
        if (!node.options) {
            result.push(tslib_1.__spreadArray(tslib_1.__spreadArray([], path, true), [item], false));
        }
        else {
            for (var _i = 0, _a = node.options.values; _i < _a.length; _i++) {
                var child = _a[_i];
                NestedListChooserState.flatten(child, tslib_1.__spreadArray(tslib_1.__spreadArray([], path, true), [item], false), result);
            }
        }
        return result;
    };
    NestedListChooserState.prototype.getSelections = function (values) {
        values = values || [];
        var selections = [];
        var group = this.formField.options;
        var _loop_2 = function (value) {
            selections.push(String(value));
            var selectedValue = group.values.find(function (f) { return String(f.value) === value; });
            group = selectedValue != null ? selectedValue.options : null;
        };
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            _loop_2(value);
        }
        var previousValues = this.value != null ? this.value : [];
        var _loop_3 = function () {
            var selectedValue = group.values[0];
            // Try to match existing selection in new group
            var previousValue = previousValues[selections.length];
            if (previousValue != null) {
                // Use == to compare strings with numbers untill we fix typing
                var equalValue = group.values.find(function (v) { return v.value == previousValue; }); // tslint:disable-line
                if (equalValue != null) {
                    selectedValue = equalValue;
                }
            }
            selections.push(String(selectedValue.value));
            group = selectedValue.options;
        };
        while (group != null && group.values.length > 0) {
            _loop_3();
        }
        return selections;
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], NestedListChooserState.prototype, "displayValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], NestedListChooserState.prototype, "groups", null);
    tslib_1.__decorate([
        mobx_1.action
    ], NestedListChooserState.prototype, "setValue", null);
    tslib_1.__decorate([
        mobx_1.action
    ], NestedListChooserState.prototype, "selectDefaultValue", null);
    return NestedListChooserState;
}(multi_list_chooser_state_1.MultiChooserState));
exports.NestedListChooserState = NestedListChooserState;
//# sourceMappingURL=nested.list.chooser.state.js.map